<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="row col-12 mb-50 mt-1 justify-content-between">
            <div class="ml-1">
                <button class="btn btn-primary ml-1" rippleEffect (click)="createDevice()">
                    <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                        class="d-none d-sm-inline-block">Referans Cihaz Ekle</span>
                </button>
            </div>
        </div>
        <div class="row d-flex justify-content-between col-md-6 col-12">
            <div class="align-items-center ml-1">
                <label class="d-flex align-items-center ml-1">
                    <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="d-flex align-items-center justify-content-end">
                <label class="d-flex align-items-center">
                    <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true" (activate)="onActivate($event)">

        <ngx-datatable-column name="Kod" prop="code" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="Tür" prop="typeName" [width]="100"></ngx-datatable-column>

        <ngx-datatable-column name="Cihaz Adı" [width]="300">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.deviceName | slice:0:20 }}{{ row.deviceName.length > 20 ? '...' : '' }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Model" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.brandName}} / {{row.modelName}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Seri No" prop="seriNo" [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Kal. Durumu" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="badge" [ngClass]="row.isCalibrationValid ? 'badge-success' : 'badge-danger'">{{row.isCalibrationValid ? 'Aktif' : 'Pasif'}}</div>
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="#" [width]="75" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <!-- stopPropagation burada ekleniyor -->
                    <button class="btn btn-icon btn-flat-warning" (click)="updateDevice(row.id, $event)">
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>